<template>
    <div class="container clearfix">
        <modal-terms></modal-terms>
        <img src="/cdn/images/loading.gif" v-if="loading" class="loading-gif">
        <modalInfo v-if="showModalInfo && load_download == false"  :offset=offset>
            <img id='popup_modal_img' class="popup_image" slot="body" v-bind:src="imageUrl" @mouseleave="leaveInfoModal()" />
            <template @mouseleave="leaveInfoModal()">
            <a slot="image-name" style="font-family: trim-light" > {{imageName}} </a>
            <a slot="body1" v-bind:href="imageUrl" style="font-family: trim-light" target="_blank" v-on:click="triggerDownloadEvents(imageUrl)"> {{ imageUrl }} </a>
            <a slot="body2" style="font-family: trim-light"> {{ (imageInfo ? imageInfo : 'no results.') }} </a>
            <span style="font-family: trim-light" slot="size">{{ imageAdditionInfo && imageAdditionInfo.size ? imageAdditionInfo.size : '' }}</span>
            <span style="font-family: trim-light" slot="dimensions">{{ imageAdditionInfo && imageAdditionInfo.width ? imageAdditionInfo.width : '0' }} X {{ imageAdditionInfo && imageAdditionInfo.height ? imageAdditionInfo.height : '0' }}</span>
            </template>
        </modalInfo>
        <div class="row">
            <div class="col-lg-12">
                <h1>Digital Asset Management</h1>
            </div>
            <div class="col-lg-8" style="display:flex;">
                <div v-if="!searchClicked" style="font-family: trim-medium;">
                    <img style="margin-bottom:4px; height:14px; " src="https://assets.rhinorack.com/Images/Others/folder_1.svg" alt="folder-icon">
                    <span v-for="(breadcrumb, index) in breadcrumbs" :key= 'index'>
                        <span v-if="(breadcrumbs.length - 1) != index" style="color: #005cb9; cursor: pointer" v-on:click="visitFromBreadCrumb(index)"> {{ breadcrumb }} </span>
                        <span v-else> {{ breadcrumb }} </span>
                        <span v-if="(breadcrumbs.length - 1) != index"> / </span>
                    </span>
                </div>
                <div style="padding: 2px;">
                    <h6>
                        <span v-if="directories.length"> / Directories - {{ directories.length }}</span>
                        <span v-if="directories.length && images.length">, </span>
                        <span v-if="totalFiles">Files - {{ totalFiles }}</span>
                    </h6>
                </div>
            </div>
            <div class="col-lg-12 products">
                <div>
                    <div class="search-products">
                        <div class="col-sm-4 col-lg-8" style="padding: 0 10px 0 0; margin-bottom: 0;">
                            <form class="search-results-input" v-on:submit.prevent="clickSearch()">
                            <input type="text" placeholder="Search for parts and products" v-model="search" v-on:keyup="enterSearch">
                            <button type="button" v-on:click="clickSearch()"></button>
                            </form>
                        </div>
                        <div class="col-lg-4" style="padding: 0 0 0 20px; margin-bottom: 0;">
                            <modalPagination
                                v-on:changePage="pageUpdated($event)"
                                :pageRange="paginationArray"
                                :pageReset.sync="pageReset"
                                :finalPage="lastIndex"
                                :currentPageShare="currentPageShare"
                                >
                            </modalPagination>
                        </div>
                    </div>
                    <div class="search-filters">
                        <div class="col-lg-4">
                        <label for="image_quality">Image Quality:</label>
                        <select id="image_quality" v-model="imageQualityFilter" @change="load">
                            <option value="">Select</option>
                            <option value="High Resolution">High Resolution</option>
                            <option value="Low Resolution">Low Resolution</option>
                        </select>
                    </div>
                    <div class="col-lg-4">
                        <label for="image_type">Image Type:</label>
                        <select id="image_type" v-model="imageTypeFilter" @change="load">
                            <option value="">Select</option>
                            <option value="Lifestyle">Lifestyle</option>
                            <option value="Product Shot">Product Shot</option>
                            <option value="Application Shot">Application Shot</option>
                            <option value="Vehicle Image">Vehicle Image</option>
                            <option value="Brand Assets">Brand Assets</option>
                            <option value="Video">Video</option>
                        </select>
                    </div>
                    <div class="col-lg-4">
                        <label for="country">Country (lifestyle images only)</label>
                        <select id="country" v-model="countryFilter" @change="load">
                            <option value="">Select</option>
                            <option value="AU/NZ">AU/NZ</option>
                            <option value="US/CA">US/CA</option>
                        </select>
                    </div>
                    </div>
                    <div class="select-download-images col-lg-12 col-md-12">
                        <button class="dam_btn select_all_btn" type="button" v-if="images.length != 0  && imageTypeFilter != 'Video'" @click="selectAllImages(images)">Select All</button>
                        <button class ="dam_btn download_selected_btn" type="button" v-if="images.length != 0  && imageTypeFilter != 'Video'" @click="removeSelectedImages(images)">Unselect All</button>
                        <button class ="dam_btn download_selected_btn" type="button" v-if="images.length != 0 && imageTypeFilter != 'Video'" @click="downloadSelectedImages(images)">Download Selected</button>
                    <div class="overlay" v-if="load_download" dusk="loading_overlay">
                        <p class="loading">
                            <img src="/cdn/images/loading.gif" width="100" />
                        </p>
                    </div>
                    </div>
                    <h4 v-if="searchClicked" style="font-family: trim-medium; font-size:16px;">
                        <span v-on:click="clearSearch()" style="color: #005cb9; cursor: pointer;">X </span> Results for {{ searchedValue }}
                    </h4>
                </div>
                <div :class="load_download == true ? 'col-lg-12 col-md-12 opacity_items' : 'col-lg-12 col-md-12'" style="margin-top: -5px; padding: 0px 0px 15px 0px;">
                    The easiest way to download is to right click the View / Save link and click Save Link As, alternatively you could share the link with your graphics team.
                     Please contact <a href="mailto:digital-support@rhinorack.com.au?subject=DAM feedback">digital-support@rhinorack.com.au</a> for any feedback related to our digital asset library.
                </div>
                <div :class="load_download == true ? 'row opacity_items' : 'row' ">
                    <div class="panel col-sm-4 col-lg-2" v-if="(!directories.length && !images.length) && searchClicked">
                    No results.
                    </div>
                    <div class="panel col-sm-4 col-lg-2" v-if="directorySlug != directoryDefaultValue">
                        <div class="item item-dam">
                            <div class="top top-image" style="padding:0;">
                                 <img v-on:click="visitToUp()" style="padding: 20px 30px; cursor: pointer;" src="https://assets.rhinorack.com/Images/Others/folder_up.svg" alt="folder-back">
                            </div>
                            <div class="bottom">
                                <div class="stock" style="background-color: #CCCCCC">
                                    <div><span style="cursor: pointer; text-transform: none; font-size: 16px; font-family: trim-medium;" >Return back</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- div class="panel col-sm-4 col-lg-2" v-for="(directory, index) in directories">
                        <div class="item item-dam">
                            <div class="top top-image" style="padding:0;">
                                <div>
                                    <img v-on:click="visitToDirectory(directory)" style="padding: 20px 30px; cursor: pointer;" src="https://assets.rhinorack.com/Images/Others/folder_1.svg" alt="folder-icon">
                                </div>
                            </div>
                            <div class="bottom">
                                <div class="stock">
                                    <div><span style="cursor: pointer; font-size: 16px; font-family: trim-medium" v-on:click="visitToDirectory(directory)">{{ directory.replace(directorySlug + '/','') }}</span></div>
                                </div>
                            </div>
                        </div>
                    </div -->
                    <div class="panel col-sm-4 col-lg-2" v-for="(image, index) in images" :key="index">
                        <div class="item item-dam">
                            <div class="top top-image">
                                <input v-if="imageTypeFilter != 'Video'" type="checkbox" :id = "image.id"  :checked="isImageChecked(image.id)" :value="image.id" @input="getSelectedImage(image.id,image.tags, image.image_url, image.image_name)" />
                                <div :id="'thumb'+image.id" class="image __fit-my-car" :style="{'background-image': 'url(' + getThumbnailUrl(image.thumbnail_url) +')'}" style="height: 100px; cursor: pointer; margin-bottom: auto;" @mouseover="clickInfo(image.id,image.tags, image.image_url, image.image_name)"  :title="image.image_url"></div>
                            </div>
                            <div class="stock img-stock-details">
                                <div style="margin-top:0px; white-space: nowrap; width: 100px; text-overflow: ellipsis; overflow: hidden;">
                                    {{ image.image_name }}
                                </div>
                                <div class="stock-details">
                                    <!-- <div style="display: flex; align-items: center;">
                                        <div style="width: unset; margin-bottom: 2px; margin-right: 5px; background-image: url('https://assets.rhinorack.com/Images/Others/Eye.svg'); height: 9px; width:13px;"></div>
                                        <div>
                                            <span style="color: #005cb9; cursor: pointer" v-on:click="clickInfo(image.tags, image.image_url, image.image_name)">Preview / Info</span>
                                        </div>
                                    </div> -->
                                    <div style="display: flex; align-items: center;">
                                        <div style="width: unset; margin-bottom: 2px; margin-right: 5px; background-image: url('https://assets.rhinorack.com/Images/Others/Download.svg'); height: 12px; width:13px;"></div>
                                        <div><a :href="image.image_url" v-on:click="triggerDownloadEvents(image.image_url)" target="_blank" download>View / Save</a></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 bottom-pagination">
                    <modalPagination
                        v-on:changePage="pageUpdated($event)"
                        :pageRange="paginationArray"
                        :pageReset.sync="pageReset"
                        :finalPage="lastIndex"
                        :currentPageShare="currentPageShare"
                        >
                    </modalPagination>
                </div>
                <div class="col-md-12 dam-banner-container" v-if="banner && banner.imageUrl && banner.isEnabled">
                    <a :href="banner.url" target="_blank">
                        <img :src="banner.imageUrl" alt="banner" class="dam-banner" />
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import modalImage from './modal-image.vue';
import modalInfo from './modal-info.vue';
import modalTerms from './modal-terms';
import modalPagination from './modal-pagination';
import JsZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import saveAs from 'file-saver';


export default {
    name: "digital-asset-management",
    props: {
    label_loading: {
      type: String,
      default: "Loading"
    },
    },
    components: {
        modalImage,
        modalInfo,
        modalPagination,
        modalTerms,
        JsZip,
        JSZipUtils,
        saveAs,
    },
    data() {
        return {
            loading: false,
            directoryDefaultValue : 'DAM',
            directoryValue : '',
            directorySlug : '',
            showModalImage: false,
            showModalInfo: false,
            search : '',
            searchedValue : '',
            searchClicked : false,
            directories : {},
            images : {},
            imageUrl : '',
            imageInfo : '',
            imageAdditionInfo : [],
            currentPage: 1,
            previousPage: null,
            pageNext: null,
            totalPages: null,
            paginationArray: [],
            totalFiles: '',
            lastIndex: null,
            pageReset: false,
            log:'',
            imageQualityFilter: '',
            imageTypeFilter: '',
            countryFilter: '',
            currentPageShare: 1,
            selectedImages:new Map(),
            SelectedImagesUrl: [],
            SelectedImageIds: [],
            allSelected: false,
            imageChanged:true,
            load_download: false,
            offset: [],
            hovered: false,
        };
    },
    props: ['banner'],
    mounted() {
        if(this.userType !='B2B'){
            setTimeout(function(){
                        window.location = '/';
                    });
        }

        this.directoryValue = this.directoryDefaultValue;
        this.directorySlug = this.directoryDefaultValue;
        this.load();
    },
    methods: {
        async load() {
            this.loading = true;
            let response = await axios.get(`/` + window.culture + `/dam/api/load?`+ new URLSearchParams(
                {
                    dir: this.directoryValue,
                    search: this.search,
                    page: this.currentPage,
                    image_quality: this.imageQualityFilter,
                    image_type: this.imageTypeFilter,
                    country: this.countryFilter
                }
            ));

            if (response.data.errorStatusCode && response.data.errorStatusCode == 400) {
                console.log('error occurred.');
            } else {
                this.directories = response.data.directories;
                this.images = response.data.images.data;
                this.loading = false;
                this.directorySlug = this.directoryValue;
                this.totalPages = response.data.images.last_page;
                this.totalFiles = response.data.images.total;
                this.pagination();
            }
            this.damAnalytics('search');
        },
        pagination() {
            var current = this.currentPage;
            var last = this.totalPages;
            var delta = 2;
            var left = current - delta;
            var right = current + delta + 1 ;
            var range = [];
            var ragngeWithDots = [];
            var l;
            for(let i=1; i <= last; i++) {
                if(i==1 || i == last || i>= left && i< right) {
                    range.push(i);
                }
            }
            for (let i of range) {
                if(l) {
                    if(i - l === 2){
                        ragngeWithDots.push(l+1);
                    } else if(i - l !==1) {
                        ragngeWithDots.push('...');
                    }
                }
                ragngeWithDots.push(i);
                l = i;
            }
            this.paginationArray = ragngeWithDots;
            this.lastIndex = ragngeWithDots[ragngeWithDots.length-1];
        },
        triggerGA(gaAction, gaLabel) {
             ga('send', 'event', "DAM", gaAction, gaLabel);
            gtag('event', 'dam', {'category':'DAM', 'action':gaAction, 'value': gaLabel});
        },
        triggerDownloadEvents(fileUrl) {
            this.damAnalytics('download', fileUrl);
            ga('send', 'event', "DAM", "Download", fileUrl);
            gtag('event', 'dam', {'category':'DAM', 'action':'Download', 'value': fileUrl});
        },
        pageUpdated(currentPage, previousPage, pageNext) {
            this.currentPage = currentPage;
            this.previousPage = previousPage;
            this.pageNext = pageNext;
            this.pageReset = false;
            this.currentPageShare = currentPage;
            this.load();
        },
        resetPage() {
            this.pageReset = true;
            this.currentPage = 1;
        },
        visitToDirectory(dir) {
            this.directoryValue = dir;
            this.resetPage();
            this.load();
        },
        visitFromBreadCrumb(index){
            var dir = '';
            for (var i = 0; i < this.breadcrumbs.length; i++) {
                if(index >= i) {
                    if(dir) dir = dir + '/';
                    dir = dir + this.breadcrumbs[i];
                }
            }
            this.visitToDirectory(dir);
        },
        visitToUp(){
            var index = this.breadcrumbs.length - 2;
            if(index < 0) index = 0;
            var dir = '';
            for (var i = 0; i < this.breadcrumbs.length; i++) {
                if(index >= i) {
                    if(dir) dir = dir + '/';
                    dir = dir + this.breadcrumbs[i];
                }
            }
            this.visitToDirectory(dir);
        },
        clickSearch(){
            if(this.search)
                this.searchClicked = true;
            else
                 this.searchClicked = false;
            this.searchedValue = this.search;
            this.log = this.search;
            this.visitToDirectory(this.directoryDefaultValue);
        },
        enterSearch: function (e) {
            if (e.keyCode === 13) {
                this.clickSearch()
            }
            else
                this.searchClicked = false;
            this.log += e.key;
        },
        clearSearch(){
            this.searchClicked = false;
            this.search = '';
            this.visitToDirectory(this.directoryDefaultValue);
        },
        // clickPreview(imageUrl){
        //     this.showModalImage = true;
        //     this.imageUrl = imageUrl;
        // },
        clickInfo(imageid,imageInfo, imageUrl, imageName){
            this.hovered = true;
            this.showModalImage = true;
            this.showModalInfo = true;
            this.imageAdditionInfo = [];
            this.imageInfo = imageInfo;
            this.imageUrl = imageUrl;
            this.imageName = imageName;
            this.imageName = this.imageName.split('.').slice(0, -1).join('.');
            this.imageExt = imageName.substr(imageName.lastIndexOf('.') + 1 );

            let element_name = 'thumb'+imageid;
            var element_position = document.getElementById(element_name).getBoundingClientRect();
            this.offset = JSON.parse(JSON.stringify( element_position ));

            axios
              .post(`/` + window.culture + `/dam/api/imageinfo`, { 'imageurl' : imageUrl })
              .then(response => {
                    this.imageAdditionInfo = response.data.data;
              })
              .catch(error => {
                console.error("Error: ", error);
              });
        },
        getOffset(el) {
          const rect = el.getBoundingClientRect();
          return {
            left: rect.left + window.scrollX,
            top: rect.top + window.scrollY
            };
        },
        leaveInfoModal(){
            this.hovered = false;
            this.showModalInfo = false;
            this.showModalImage = false;
        },
        getThumbnailUrl(imageUrl) {

            let placeholderUrl = 'https://assets.rhinorack.com/DAM/PlaceholderImages/';

            let imgType = (imageUrl.match(/\.(eps|pdf|doc|xlsx|ai|txt)$/i));
            if(imgType){
                 placeholderUrl = placeholderUrl + imgType[1] + '.png';
            }

            if(!imageUrl && !imgType){
                placeholderUrl = 'https://assets.rhinorack.com/DAM/PlaceholderImages/placeholder.png';
            }

            return imgType ? encodeURI(placeholderUrl) : encodeURI(imageUrl);
        },
        async damAnalytics(action, fileUrl = null) {
            let  { firstname, lastname, email, companyname } = this.profile;
            if((action == 'search' && this.searchClicked) || action == 'download' ) {
                axios.post(`/${this.getCulture}/api/dam-analytics`, {
                    action,
                    firstname,
                    lastname,
                    email,
                    companyname,
                    file_url: fileUrl ,
                    keyword: this.search,
                    country_filter: this.countryFilter,
                    image_quality_filter: this.imageQualityFilter,
                    image_type_filter: this.imageTypeFilter,
                    culture: this.getCulture,
                });
          }
        },
        isImageChecked(id){
           return this.SelectedImageIds.includes(id);
        },
        getSelectedImage(id,imageInfo, image_url, imageName){
            let selectedId = this.SelectedImageIds.includes(id);
            let selectedIds = [...this.SelectedImageIds];
            let selectedImagesUrl = [...this.SelectedImagesUrl];
            if(selectedId === true){
                    this.SelectedImageIds=selectedIds.filter((selectedId)=>{
                    return selectedId !== id;
                });
                    this.SelectedImagesUrl=selectedImagesUrl.filter((selectedImageUrl)=>{
                    return selectedImageUrl !== image_url;
                });
                return;
            }
            selectedIds.push(id);
            selectedImagesUrl.push(image_url);
            this.SelectedImageIds=[...selectedIds];
            this.SelectedImagesUrl=[...selectedImagesUrl];

        },
        selectAllImages(images){
            this.selectedImages.clear();
            this.SelectedImageIds = [];
            this.SelectedImagesUrl = [];
            images.forEach( ({image_url,id})=> {
                this.SelectedImageIds.push(id);
                this.SelectedImagesUrl.push(image_url);
            });            
        },
        downloadSelectedImages(){
            this.load_download = true;
            var links = this.SelectedImagesUrl;
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            axios
            .post(`/` + window.culture + `/dam/api/downloadSelectedImages`, { 'links' : links },{responseType: 'arraybuffer',})
            .then(response => {
                let blob = new Blob([response.data]),
                url = window.URL.createObjectURL(blob)
                a.href = url;
                a.setAttribute('download', 'images.zip');
                document.body.appendChild(a);
                a.click();
                this.load_download = false;
            })
            .catch(error => {
            this.load_download = false;
            console.error("Error: ", error);
            });
        },
        removeSelectedImages(){
            this.SelectedImageIds = [];
            this.SelectedImagesUrl = [];
        }
    },
    computed: {
        breadcrumbs() {
            return this.directoryValue.split('/');
        },
        userType() {
          return this.$store.getters["auth/userType"];
        },
        profile() {
            return this.$store.state.auth.profile;
        },
        getCulture() {
            return window.culture;
        },
    }
};
</script>
<style scoped>

    .popup_image{
        width: 500px; 
        max-height: 40vh; 
    }
    @media only screen and (max-width: 768px) {
    .popup_image {
        width: 355px;
        }
    }

    @media only screen and (max-width: 600px) {
    .popup_image {
        width: 80vw;
        }
    }

  .loading-gif {
            margin: 0;
            position: absolute;
            top: 50%;
            left: 50%;
            margin-right: -50%;
            transform: translate(-50%, -50%);
            width : 35px;
            height : 35px;
            z-index:1;
        }

    .search-filters {
        display: flex;
        padding-top: .5rem;
        padding-bottom: 1rem;
        flex-wrap: wrap;

    }
    @media only screen and (max-width: 449px) {
    .search-products{
        flex-direction: column;
        }
    }
    .select-download-images{
        margin-bottom: 2rem;
    }
    label {
        margin-top: .5rem;
    }
    select {
        width: 100%;
        height: 40px;
        line-height: 2;
        padding: 10px;
    }

    .dam-banner-container {
        padding-bottom: 1.5rem;
        display: flex;
        justify-content: center;
    }

    .dam-banner {
        max-width:1140px;
        width: 90vw;
    }
    .bottom-pagination {
        display: flex;
        justify-content: center;
        padding: 1rem 0;
    }
    .img-stock-details{
        min-height: initial !important;
   }
   .dam_btn{
        background-color: #e3e3e3;
        font-family: "trim-light";
        letter-spacing: 1px;
        color: #000;
        border: 1px solid rgba(0, 0, 0, 0.1);
        padding: 5px 6px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        font-size: 16px;
        margin: 4px 2px;
        cursor: pointer;
        opacity: 1
   }

   .overlay{
    z-index: 1;
    position: relative;
    top: 100px;
    display: flex;
    justify-content: center;
   }

   .opacity_items{
    opacity: 0.2;
   }

</style>